var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","open-on-hover":"","open-delay":500},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.smartFavoriteSwitch(_vm.voicemail)}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(_vm._s(_vm.voicemail.favoriteIcon))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t('vmail.tip.addToFavorites')))])])}
var staticRenderFns = []

export { render, staticRenderFns }